module.exports = "/dist/4bfa3523a35afe38a3331bb14a0121cb.png";